import React, { useState } from "react";
import violentometro from './images/violentometro.png';
import derechoslegales from './images/derechoslegales.jpeg';
import apoyopsicologico from './images/apoyopsicologico.jpeg';
import violenciafisica from './images/violenciafisica.avif';
import violenciaPsicologica from './images/violenciaPsicologica.jpeg';
import ViolenciaSexual from './images/ViolenciaSexual.jpeg';
import ViolenciaEconomica from './images/ViolenciaEconomica.jpeg';
import ViolenciaSimbolica from './images/ViolenciaSimbolica.jpeg';
import ViolenciaPatrimonial from './images/ViolenciaPatrimonial.avif';
import evento1 from './images/accesos/CentrosJusticia.jpg';
import evento2 from './images/accesos/Num_Emergencia.png';
import evento3 from './images/accesos/Test.png';
import evento4 from './images/accesos/Podcast.jpg';
import { useNavigate } from 'react-router-dom';


const EstamosContigo = ({ id, title, content }) => {

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate('/test');
    }
    const handleMapaRedirect = () => {
        navigate('/numeros-de-emergencia');
    };


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const openModal1 = () => setIsModalOpen1(true);
    const closeModal1 = () => setIsModalOpen1(false);

    const whatsappUrl1 = "https://wa.me/522221133330?text=Hola%20Psicóloga%20Diana%20Serrano,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";
    const whatsappUrl = "https://wa.me/529531776747?text=Hola%20Licenciada%20Gabriela%20Sarabia,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";


  return (
    <div id={id || 'estamoscontigo'} className="bg-[#f8faf9] text-center font-sans text-[#24363a]">
        
        <section className=" text-gray-800 p-8">
        {/*Seccion agregada */}

        <section className="text-gray-800 p-8">
            <h2 className="text-2xl font-bold mb-8 text-center">Estamos contigo</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 font-sans">
                {/* Acompañamiento Psicosocial */}
                <div id="psicologico" className="rounded-md bg-[#173f46] p-6 text-white shadow-md">
                <h3 className="text-xl font-semibold mb-2">Acompañamiento Psicológico</h3>
                <p className="mb-4">Consultas psicológicas individuales y grupales para mujeres víctimas.</p>
                <button 
                    className="w-full rounded-md bg-[#26756f] px-4 py-2 hover:bg-[#1d5d58]" 
                    onClick={openModal1}
                >
                    Agendar una cita
                </button>
                {isModalOpen1 && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg p-4 shadow-lg max-w-sm w-full">
                        <h2 className="text-xl font-bold mb-2">Contacto</h2>
                        <p className="mb-4 text-gray-500">
                            <strong>Psicóloga Diana Serrano</strong>
                        </p>
                        <div className="flex justify-center text-center mb-2">
                            <a
                                href={whatsappUrl1}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="py-2 w-full bg-green-500 text-white rounded-lg hover:bg-green-600"
                            >
                                Contactarla por WhatsApp
                            </a>
                        </div>
                        <button
                            className="w-full py-2 px-4 bg-black rounded-lg hover:bg-gray-300 text-gray-200"
                            onClick={closeModal1}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
                </div>

                {/* Asesoría Jurídica */}
                <div className="rounded-md bg-[#173f46] p-6 font-sans text-white shadow-md">
                <h3 className="text-xl font-semibold mb-2">Asesoría Jurídica</h3>
                <p className="mb-4">Asesoría legal gratuita sobre derechos y pasos a seguir para denunciar.</p>
                <button 
                    className="mt-1 w-full rounded-md bg-[#26756f] px-4 py-2 hover:bg-[#1d5d58]" 
                    onClick={openModal}
                >
                    Necesito asesoría
                </button>
                {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg p-4 shadow-lg max-w-sm w-full">
                        <h2 className="text-xl font-bold mb-2">Contacto</h2>
                        <p className="mb-4 text-gray-500">
                            <strong>Abogada Gabriela Sarabia</strong>
                        </p>
                        <div className="flex justify-center text-center mb-2">
                            <a
                                href={whatsappUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="py-2 w-full bg-green-500 text-white rounded-lg hover:bg-green-600"
                            >
                                Contactarla por WhatsApp
                            </a>
                        </div>
                        <button
                            className="w-full py-2 px-4 bg-black rounded-lg hover:bg-gray-300 text-gray-200"
                            onClick={closeModal}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            )}
                </div>

                {/* Red de Apoyo */}
                <div className="rounded-md bg-[#173f46] p-6 font-sans text-white shadow-md">
                <h3 className="text-xl font-semibold mb-2">Red de Apoyo</h3>
                <p className="mb-4">Asistente virtual 24/7 y chat en vivo con profesionales.</p>
                <button href="#chatbot"
                    className="mt-6 w-full rounded-md bg-[#26756f] px-4 py-2 hover:bg-[#1d5d58]" 
                    
                >
                    Ir al chat
                </button>
                </div>
            </div>
            </section>
        </section>
        <div id="test" className="py-20 text-gray-500" style={{ backgroundColor: '#f4f4f4' }}>
                    {/* Título centrado */}
                    <h1 className="text-3xl font-semibold text-center my-10 text-[#9775bb]">
                        Test de Riesgo
                        <p className='text-lg text-gray-800 mt-2 px-8 text-justify font-medium items-center'>
                            El Violentómetro es una herramienta creada para identificar y prevenir diferentes formas de violencia, especialmente en relaciones de pareja, pero también en ámbitos laborales, educativos y familiares.
                        </p>
                        <p className="text-1xl font-semibold text-[#37a7c1]">Hacer el test &emsp;
                            <button className="px-3 py-1 text-white bg-[#37a7c1] hover:bg-[#c4c9ff] rounded-xl" onClick={handleRedirect} >
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </p>
                    </h1>

                    <div className=" items-center flex justify-center ">
                        <img src={violentometro} alt="Violentómetro" className="w-80" />
                    </div>
                </div>
    </div>
  );
};

export default EstamosContigo;
